/* Built In Imports */
import Head from 'next/head';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import { EnrollContextProvider } from '@ieo/Components/Form/ieo/context/enrollContext';
import IeoThankYouPageSection from '@ieo/Sections/ThankYouPageSection';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  filterBuildUrls,
  getCurrentRegion,
  getLatestBuild,
} from 'services/commonService';
import { fetchDetailsIeo, fetchIEOPrgData } from 'services/ieoService';

/* Styles */

// TODO: Fetch this from Dato, this is same as IEO page first two sections
const sectionContent = [
  {
    id: '175171988',
    titleDecoration: '',
    titleSubtext: 'Enroll in the ',
    titleText: 'Program',
    _modelApiKey: 'section_title',
  },
  {
    id: '175171989',
    fieldId: '',
    _modelApiKey: 'single_image',
    image: {
      url: 'https://static.sadhguru.org/d/46272/1694419719-enroll-section.png',
      title: null,
      alt: null,
      size: 127440,
    },
    mobileImage: null,
    tabletImage: null,
  },
];

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Inner Engineering Register page Data
 */
const InnerEngineeringThank = ({ region, language, pageData }) => {
  const [programData, setProgramData] = useState('');
  // console.log('InnerEngineeringThank', pageData);

  useEffect(() => {
    localData();
  }, []);

  const localData = async () => {
    const reg = await getCurrentRegion();
    if (reg?.country) {
      const ieoPrgList = await fetchIEOPrgData(reg?.country?.toUpperCase());
      setProgramData(ieoPrgList?.data);
    }
  };

  return (
    <WrapLayout pageData={pageData}>
      {region == 'in' && (
        <Head>
          <link
            rel="preconnect"
            href="https://dev.visualwebsiteoptimizer.com"
          />

          <script
            dangerouslySetInnerHTML={{
              __html: `
            window._vwo_code || (function() {
            var account_id=872818,
            version=2.1,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var i=this.getSettings(),n=d.createElement('script'),r=this;t=t||{};if(i){n.textContent=i;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200){w._vwo_code.addScript({text:o.responseText})}else{w._vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}w._vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var i=this.hide_element(),n=i?i+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=n;else t.appendChild(d.createTextNode(n));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var n=d.createElement('div');n.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';n.setAttribute('id','_vis_opt_path_hides');n.classList.add('_vis_hide_layer');t.parentNode.insertBefore(n,t.nextSibling)}var o='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:o})}else{this.load(o+'&x=true')}}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
            `,
            }}
          />
        </Head>
      )}
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Box as="section" p="0" maxW="1920px" w="100%" m="0 auto 100px">
        {/*Thank You page starts here*/}
        {/*{pageData?.body?.length &&*/}
        {/*  pageData.body[0]?.value?.map(section => {*/}
        {/*    return (*/}
        {/*      <RenderSections*/}
        {/*        pageData={pageData}*/}
        {/*        section={section}*/}
        {/*        region={region}*/}
        {/*        lang={language}*/}
        {/*        key={nanoid(4)}*/}
        {/*        csrData={programData}*/}
        {/*      />*/}
        {/*    );*/}
        {/*  })}*/}
        {pageData?.body && (
          <EnrollContextProvider>
            <IeoThankYouPageSection
              pageData={pageData}
              lang={language}
              maxW={1110}
              sectionContent={pageData?.body[0]?.sectionContent}
              bodyData={pageData?.body}
            />
          </EnrollContextProvider>
        )}
      </Box>

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,324804,344111);`,
        }}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,324804,'u8welaoz8o8bcqac8osu');`,
        }}
      />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let ieoLandingPaths = config.USE_LOCAL_URL
    ? [
      `/in/en/inner-engineering/register/thankyou`,
      `/us/en/inner-engineering/register/thankyou`,
      `/global/ar/inner-engineering/register/thankyou`,
      `/global/id/inner-engineering/register/thankyou`,
    ]
    : [];
  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    const data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    ieoLandingPaths = filterBuildUrls(
      'landing_pages',
      'L2',
      '/inner-engineering/register/thankyou',
      '',
      data
    );
  }
  return {
    paths: ieoLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetailsIeo(
    region,
    language,
    '/register/thankyou',
    {
      preview,
      data: previewData,
    }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      hideTopMenu: true,
      showHeader: false,
    },
  };
};

export default InnerEngineeringThank;
